import React    from 'react';
import { Link } from 'react-router';

let FaCheck     = require('react-icons/lib/fa/check');
let StepManager = require('../Managers/Steps');
let classNames  = require('classnames');

const HeaderSteps = React.createClass({
    propTypes: {
        steps: React.PropTypes.array.isRequired,
        totalNumberOfSteps: React.PropTypes.number.isRequired,
        current: React.PropTypes.number.isRequired,
        complete: React.PropTypes.number.isRequired,
        hasQuote: React.PropTypes.bool.isRequired,
        moveTo: React.PropTypes.func,
        onReRender: React.PropTypes.func,
    },

    move(targetStep) {
        this.props.moveTo(targetStep);
    },

    render() {
        let steps = this.props.steps;
        if (steps == undefined || steps.length == 0) {
            steps = StepManager.getSteps();
        }
        let totalStepCount = steps.length;

        let stepWidth = 100 / totalStepCount;
        let stepStyle = { width: stepWidth + '%' };

        let stepsClasses = classNames({
            steps: true,
            landlords: true,
            'short-journey': StepManager.totalNumberOfSteps() < 4 ? true : false,
        });

        return (
            <div className="container">
                <div className={stepsClasses}>
                    <div className="step complete pointer" style={stepStyle} onClick={this.move.bind(this, 'start')}>
                        <div>
                            <Link className="circle" to="/start">
                                <FaCheck className="fa-2x" />
                            </Link>
                            <Link to="/start" className="text">About your cover</Link>
                        </div>
                    </div>

                    {steps.map(function(title, index) {
                        let adjustedIndex = parseInt(index)+2;
                        let classes = classNames({
                            step: true,
                            current: (this.props.current == index),
                            complete: ((StepManager.canMoveToStep(index) && index < this.props.current) || this.props.hasQuote),
                            pointer: (StepManager.canMoveToStep(index) && this.props.current != index),
                        });

                        return (
                            <div className={classes} key={index} style={stepStyle}>
                                {this.props.current == index ? (
                                    <div key={index}>
                                        <div className="circle">
                                            <FaCheck className="fa-2x" /><span className="number">{adjustedIndex}</span>
                                        </div>
                                        <div className="text">{title}</div>
                                    </div>
                                ) : (
                                    <div key={index} onClick={this.move.bind(this, index)}>
                                        <div className="circle">
                                            <FaCheck className="fa-2x" /><span className="number">{adjustedIndex}</span>
                                        </div>
                                        <div className="text">{title}</div>
                                    </div>
                                )}
                            </div>
                        );
                    }, this)}
                </div>
            </div>
        );
    }
});

export default HeaderSteps;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/HeaderSteps.js
 **/